export default __webpack_public_path__ + "static/media/refpay-b.b81fb19b.svg";